import React from "react";
import Link from "./Link";
import {Typography} from "@mui/material";
import {useLocation} from "react-router-dom";
import {defaultProps} from "recompose";

class MenuItems extends React.Component {


    /***************
     * CONSTRUCTOR *
     ***************/

    /**
     * did mount
     */
    componentDidMount() {
        // restore events when re-render
        this.setEvents();
    }

    /**
     * constructor
     */
    constructor(props) {
        super(props);

        // add object for the underline management
        this.createUnderlineObj('menuSelector');

        // set the events
        this.setEvents();
    }


    /*const initHoverObj = () => {
        hoverObj.id = 'menuSelector';
        document.body.appendChild(hoverObj);
    }
    const setEvents = () => {
        window.addEventListener("resize", resetHoverPosition);
    }
    const resetHoverPosition = () => {
        hoverObj.style.left = 0;
    }

    const onOut = (event, data) => {
        hoverObj.style.opacity = 0;
    }

    const onHover = (event, data) => {
        if (event.target.classList === 'link active') return;

        setHoverObjStyle(event.target.getBoundingClientRect());
    }

    const setHoverObjStyle = (position) => {
        hoverObj.style.opacity = 1;
        hoverObj.style.left=position.x+'px';
        hoverObj.style.top=(position.y+(position.height-2)+document.documentElement.scrollTop)+'px';
        hoverObj.style.width = position.width+'px';
    }

    const menuItems = menu.map((menuItem, key) =>  {
        const active = menuItem.path === location.pathname;
        return <Link
            route={menuItem}
            key={key}
            className={active ? "link active" : "link"}
            onMouseEnter={onHover}
            onMouseLeave={onOut}
            exact
        />
    });*/

    /**********
     * EVENTS *
     **********/

    /**
     * set the components events
     */
    setEvents(){
        // Prevent selector to be outside windows when resize
        //window.addEventListener("resize", this.resetHoverPosition.bind(this));
        window.addEventListener("resize", this.resetHoverPosition);
    }

    /**
     * set the onOut events
     * @note This notation = () => prevent to have to bind this
     */
    onOut = (e, data) => {
        // hide the hover object
        this.hoverObj.style.opacity = 0;
    }

    /**
     * set the onOver events
     * @note This notation = () => prevent to have to bind this
     */
    onHover = (e, data) => {
        if(e.target.classList==='link active') return;

        // set hover styles
        this.setHoverObjStyle(e.target.getBoundingClientRect());
    };


    /**
     * Reset the position of hover
     * @note This notation = () => prevent to have to bind this
     */
    resetHoverPosition = () => {
        this.hoverObj.style.left = 0;
    }

    /***********
     * METHODS *
     ***********/

    /**
     * Create the object used to underline selection dynamically with animation
     */
    createUnderlineObj(id){
        this.hoverObj = document.createElement('div');
        this.hoverObj.id = id;
        document.body.appendChild(this.hoverObj);
    }

    /**
     * Set the hoverObj styles
     */
    setHoverObjStyle(position){
        // set hover menu position
        this.hoverObj.style.opacity = 1;
        this.hoverObj.style.left=position.x+'px';
        this.hoverObj.style.top=(position.y+(position.height-2)+document.documentElement.scrollTop)+'px';
        this.hoverObj.style.width=position.width+'px';
    }


    /*return <Typography className="menuLinks">
        {menuItems}
    </Typography>*/


    /**********
     * RENDER *
     **********/

    /**
     * Render the component
     */
    render() {
        const menus = Object.keys(this.props.menus).map( key =>
            <Link
                route={this.props.menus[key]}
                key={key}
                className="link"
                // onMouseEnter={this.onHover}
                // onMouseLeave={this.onOut}
            />
        );

        return (
            <Typography className="menuLink">
                {menus}
            </Typography>
        );
    }
}

/*********
 * PROPS *
 *********/

MenuItems.withDefaultProps = defaultProps({
    menus: [],
});

export default MenuItems;
